import { Sorter } from '@/modules/common/components/sorter';
import styles from './index.module.sass';
import { useState } from 'react';
import { MixItem } from '@/modules/common/components/mix-item';
import { WarehouseBadge } from './components/warehouse-badge';

export const CrossMixingContent = () => {
  const [orderBy, setOrderBy] = useState('asc');
  const [sorterOptions, setSorterOptions] = useState([
    {
      label: 'выгоде от микса',
      val: 'profit',
      active: true,
    },
  ]);
  const mockData = [
    {
      id: 1,
      weight: 5479,
      price_all: 72350000,
      price_per_ton: 32000,
      buyer: 'ИП “Пупкин”',
      logit_price: 50000,
      nett_price: 72300000,
      profit: 4000000,
      whs: [
        {
          title: 'склад на Остраханского',
          sleevesQty: 6,
          distance: 500,
          logit_price: 20000,
        },
        { title: 'склад 222', sleevesQty: 6, distance: 500, logit_price: 20000 },
      ],
    },
    {
      id: 2,
      weight: 4890,
      price_all: 72350000,
      price_per_ton: 32000,
      buyer: 'ИП “Пупкин”',
      logit_price: 40000,
      nett_price: 72310000,
      profit: 3900000,
      whs: [
        {
          title: 'склад на Остраханского',
          sleevesQty: 6,
          distance: 500,
          logit_price: 20000,
        },
        { title: 'склад 222', sleevesQty: 6, distance: 500, logit_price: 20000 },
      ],
    },
  ];
  return (
    <div className={styles.root}>
      <Sorter
        sortOption={sorterOptions}
        setSortOption={setSorterOptions}
        orderBy={orderBy as 'asc' | 'desc'}
        setOrderBy={setOrderBy}
      />
      <div className={styles.itemsList}>
        {mockData.map((item) => (
          <MixItem
            params={[]}
            mode="mix"
            idx={item.id}
            pricePerTon={item.price_per_ton}
            buyer={item.buyer}
            weight={item.weight}
            price={item.price_all}
            nettPrice={item.nett_price}
            profit={item.profit}
            onClick={() => {}}
            logitPrice={0}
            whs={
              <WarehouseBadge
                name={[item.whs[0].title, item.whs[1].title]}
                distance={[item.whs[0].distance, item.whs[1].distance]}
                sleevesQty={[item.whs[0].sleevesQty, item.whs[1].sleevesQty]}
                price={[item.whs[0].logit_price, item.whs[1].logit_price]}
              />
            }
          />
        ))}
        <span className={styles.bottomLabel}>... иных вариантов не найдено ...</span>
      </div>
    </div>
  );
};
